import { gql } from "@apollo/client";

export const FEATURES = gql`
  query AllFeatures {
    features {
      featureName
      enabled
      treatment
    }
  }
`;
